/*=========================================================================================
  File Name: getters.js
  namespace: videos
  Description: Vuex Store - Video getters
==========================================================================================*/
import {
  buildVideoState
} from './state'

const getters = {
  getCurrentVideo: state => {
    return state.currentVideo
  },
  getNewVideo: () => {
    return buildVideoState()
  },
  getVideoList: state => {
    return {
      results: state.results,
      count: state.count
    }
  },
  getVideoEntries: state => {
    return state.videoList
  },
  getCurrentVideoFiles: state => {
    return state.currentVideoFiles
  }
}

export default getters
